export const LINKS = {
    site: 'https://www.aframe.studio/',
    email: 'mailto:connect@aframe.studio',
    dribble: 'https://dribbble.com/aframe-studio',
    instagram: 'https://www.instagram.com/aframe.studio/',
    linkedIn: 'https://www.linkedin.com/company/aframe-studio',
}

export const BREAKPOINTS = {
    xl: 1400,
    lg: 1024,
    md: 768,
    sm: 425,
    nav: 736,
}

const isBreakpoint = (point: number) => window.innerWidth <= point;

const isMobileBrowser = () => /Android|iPhone/i.test(navigator.userAgent);

export const testIsSmallBreakpoint = () => window.innerWidth <= BREAKPOINTS.sm;

export const testIsNavBreakpoint = () => window.innerWidth <= BREAKPOINTS.nav;

export const testIsMobile = () => isBreakpoint(BREAKPOINTS.sm) && isMobileBrowser();

export const ANIM_SPECS = {
    ease: 'power2.out',
    scrup: testIsMobile() ? true : 2,
}

